import { createSlice } from "@reduxjs/toolkit";
const initialState = {  switch_casesheet_tabs:[],current_tab:"",switch_vc_tabs:[],switch_prescription_tabs:[],current_prescription_tab:"" };

const tabsReducer = createSlice({
  name: "switch_tabs",
  initialState,
  reducers: {

    switchCasesheetTabs(state,action){
      state.switch_casesheet_tabs = action.payload;
    },
    currentTab(state,action){
    state.current_tab = action.payload;
    },
    switchVCTab(state,action){
      state.switch_vc_tabs = action.payload;
    },
 switchPrescriptionTabs(state,action){
  state.switch_prescription_tabs=action.payload
 },
    currentPrescriptionTab(state, action) {
      state.current_prescription_tab= action.payload
    },
    switchStressTabs(state,action){
      state.switch_stress_tabs = action.payload;
    },



  },
});
export const { switchCasesheetTabs, currentTab,switchVCTab,switchPrescriptionTabs,currentPrescriptionTab,switchStressTabs} = tabsReducer.actions;
export default tabsReducer.reducer;